// ag-grid localization for Chinese (Simplified) -- zh-Hans
// we will use this for zh-Hans, zh-Hans-CN, zh-Hans-SG, zh-Hans-HK, zh-Hans-MO, zh-Hans-TW?

export default {
    // Set Filter
    selectAll: '（全选）',
    selectAllSearchResults: '（全选搜索结果）',
    searchOoo: '搜索...',
    blanks: '（空白）',
    noMatches: '无匹配项',

    // Number Filter & Text Filter
    filterOoo: '筛选...',
    equals: '等于',
    notEqual: '不等于',
    empty: '请选择',

    // Number Filter
    lessThan: '小于',
    greaterThan: '大于',
    lessThanOrEqual: '小于或等于',
    greaterThanOrEqual: '大于或等于',
    inRange: '介于',
    inRangeStart: '到',
    inRangeEnd: '从',

    // Text Filter
    contains: '包含',
    notContains: '不包含',
    startsWith: '开头是',
    endsWith: '结尾是',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: '与',
    orCondition: '或',

    // Filter Buttons
    applyFilter: '应用',
    resetFilter: '重置',
    clearFilter: '清除',
    cancelFilter: '取消',

    // Filter Titles
    textFilter: '文本筛选器',
    numberFilter: '数字筛选器',
    dateFilter: '日期筛选器',
    setFilter: '集合筛选器',

    // Side Bar
    columns: '列',
    filters: '筛选器',

    // columns tool panel
    pivotMode: '数据透视模式',
    groups: '行分组',
    rowGroupColumnsEmptyMessage: '将列拖到此处以设置行分组',
    values: '值',
    valueColumnsEmptyMessage: '将列拖到此处以进行汇总',
    pivots: '列标签',
    pivotColumnsEmptyMessage: '将列拖到此处以设置列标签',

    // Header of the Default Group Column
    group: '分组',

    // Other
    loadingOoo: '加载中...',
    noRowsToShow: '没有可显示的行',
    enabled: '已启用',

    // Menu
    pinColumn: '固定列',
    pinLeft: '固定在左侧',
    pinRight: '固定在右侧',
    noPin: '不固定',
    valueAggregation: '值汇总',
    autosizeThiscolumn: '自动调整此列大小',
    autosizeAllColumns: '自动调整所有列大小',
    groupBy: '分组依据',
    ungroupBy: '取消分组依据',
    resetColumns: '重置列',
    expandAll: '全部展开',
    collapseAll: '全部折叠',
    copy: '复制',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: '复制（含表头）',
    paste: '粘贴',
    ctrlV: 'Ctrl+V',
    export: '导出',
    csvExport: '导出为 CSV',
    excelExport: '导出为 Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: '求和',
    min: '最小值',
    max: '最大值',
    none: '无',
    count: '计数',
    avg: '平均值',
    filteredRows: '已筛选',
    selectedRows: '已选择',
    totalRows: '总行数',
    totalAndFilteredRows: '行数',
    more: '更多',
    to: '至',
    of: '共',
    page: '页',
    nextPage: '下一页',
    lastPage: '末页',
    firstPage: '首页',
    previousPage: '上一页',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: '数据透视图和数据透视模式',
    pivotChart: '数据透视图',
    chartRange: '图表范围',

    columnChart: '柱形图',
    groupedColumn: '簇状',
    stackedColumn: '堆积',
    normalizedColumn: '百分比堆积',

    barChart: '条形图',
    groupedBar: '簇状',
    stackedBar: '堆积',
    normalizedBar: '百分比堆积',

    pieChart: '饼图',
    pie: '饼图',
    doughnut: '圆环图',

    line: '折线图',

    xyChart: 'X Y (散点图)',
    scatter: '散点图',
    bubble: '气泡图',

    areaChart: '面积图',
    area: '面积图',
    stackedArea: '堆积',
    normalizedArea: '百分比堆积',

    histogramChart: '直方图',

    // Charts
    pivotChartTitle: '数据透视图',
    rangeChartTitle: '范围图表',
    settings: '设置',
    data: '数据',
    format: '格式',
    categories: '类别',
    defaultCategory: '（无）',
    series: '系列',
    xyValues: 'X Y 值',
    paired: '配对模式',
    axis: '坐标轴',
    navigator: '导航器',
    color: '颜色',
    thickness: '粗细',
    xType: 'X 类型',
    automatic: '自动',
    category: '类别',
    number: '数字',
    time: '时间',
    xRotation: 'X 轴旋转',
    yRotation: 'Y 轴旋转',
    ticks: '刻度',
    width: '宽度',
    height: '高度',
    length: '长度',
    padding: '内边距',
    spacing: '间距',
    chart: '图表',
    title: '标题',
    titlePlaceholder: '图表标题 - 双击以编辑',
    background: '背景',
    font: '字体',
    top: '顶部',
    right: '右侧',
    bottom: '底部',
    left: '左侧',
    labels: '标签',
    size: '大小',
    minSize: '最小大小',
    maxSize: '最大大小',
    legend: '图例',
    position: '位置',
    markerSize: '标记大小',
    markerStroke: '标记描边',
    markerPadding: '标记内边距',
    itemSpacing: '项目间距',
    itemPaddingX: '项目内边距 X',
    itemPaddingY: '项目内边距 Y',
    layoutHorizontalSpacing: '水平间距',
    layoutVerticalSpacing: '垂直间距',
    strokeWidth: '描边宽度',
    offset: '偏移量',
    offsets: '偏移量',
    tooltips: '工具提示',
    callout: '标注',
    markers: '标记',
    shadow: '阴影',
    blur: '模糊',
    xOffset: 'X 偏移量',
    yOffset: 'Y 偏移量',
    lineWidth: '线宽',
    normal: '正常',
    bold: '粗体',
    italic: '斜体',
    boldItalic: '粗斜体',
    predefined: '预定义',
    fillOpacity: '填充不透明度',
    strokeOpacity: '线条不透明度',
    histogramBinCount: '分箱数量',
    columnGroup: '柱形图',
    barGroup: '条形图',
    pieGroup: '饼图',
    lineGroup: '折线图',
    scatterGroup: 'X Y (散点图)',
    areaGroup: '面积图',
    histogramGroup: '直方图',
    groupedColumnTooltip: '簇状',
    stackedColumnTooltip: '堆积',
    normalizedColumnTooltip: '百分比堆积',
    groupedBarTooltip: '簇状',
    stackedBarTooltip: '堆积',
    normalizedBarTooltip: '百分比堆积',
    pieTooltip: '饼图',
    doughnutTooltip: '圆环图',
    lineTooltip: '折线图',
    groupedAreaTooltip: '面积图',
    stackedAreaTooltip: '堆积',
    normalizedAreaTooltip: '百分比堆积',
    scatterTooltip: '散点图',
    bubbleTooltip: '气泡图',
    histogramTooltip: '直方图',
    noDataToChart: '没有可用于绘制图表的数据。',
    pivotChartRequiresPivotMode: '数据透视图需要启用数据透视模式。',
    chartSettingsToolbarTooltip: '菜单',
    chartLinkToolbarTooltip: '已链接到表格',
    chartUnlinkToolbarTooltip: '已取消链接到表格',
    chartDownloadToolbarTooltip: '下载图表',

    // ARIA
    ariaHidden: '隐藏',
    ariaVisible: '可见',
    ariaChecked: '已选中',
    ariaUnchecked: '未选中',
    ariaIndeterminate:'不确定',
    ariaColumnSelectAll: '切换全选所有列',
    ariaInputEditor: '输入编辑器',
    ariaDateFilterInput: '日期筛选器输入框',
    ariaFilterInput: '筛选器输入框',
    ariaFilterColumnsInput: '列筛选器输入框',
    ariaFilterValue: '筛选值',
    ariaFilterFromValue: '从此值开始筛选',
    ariaFilterToValue: '筛选到此值',
    ariaFilteringOperator: '筛选运算符',
    ariaColumnToggleVisibility: '切换列可见性',
    ariaColumnGroupToggleVisibility: '切换列分组可见性',
    ariaRowSelect: '按空格键选择此行',
    ariaRowDeselect: '按空格键取消选择此行',
    ariaRowToggleSelection: '按空格键切换行选择',
    ariaRowSelectAll: '按空格键切换所有行选择',
    ariaSearch: '搜索',
    ariaSearchFilterValues: '搜索筛选值'
}